<template>
    <footer>
        <div class="footerWrap">
            <div class="footer-list">
                <div class="footer-social">
                    <a href="#" class="footer-fb">
                        <img src="../assets/img/footer_fb.svg" alt="FB">
                    </a>
                    <a href="#" class="footer-ig">
                        <img src="../assets/img/footer_ig.svg" alt="IG">
                    </a>
                    <a href="#" class="footer-line">
                        <img src="../assets/img/footer_line.svg" alt="line">
                    </a>
                    <a href="#" class="footer-email">
                        <img src="../assets/img/footer_email.svg" alt="email">
                    </a>
                </div>
                <div class="more-info">
                    <ul class="js-menu">
                        <li>
                            <a href="#">MEMBERSHIP
                            </a>
                        </li>
                        <li>
                            <a href="#">ABOUT Hermosa
                            </a>
                        </li>
                        <li>
                            <a href="#">INFORMATION</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="footer-mail">
                <div class="footer-letter">
                    <label for="">NEWSLETTER </label>
                    <input type="text" placeholder="E-mail">
                    <a href="javascript:void(0)">
                        <img src="../assets/img/arrow_next_dark.svg" alt="" width="6px">
                    </a>
                </div>
                <div>
                    <p class="footer-service">SERVICE</p>
                    <p class="footer-content">客服信箱 <a href="mailto:service@hermosa.com">service@hermosa.com</a> </p>
                    <p class="footer-content">客服電話 02-1234-5678 | 週一至週五 10:00-12:30 13:30-17:00</p>
                </div>
            </div>
            <div class="footer-bottom">
                <p class="footer-copy">&copy; Hermosa All Rights Reserved.</p>
                <p>本網頁僅供學習使用 無任何商業用途</p>
            </div>
        </div>
    </footer>
</template>
